// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3yzWq","title":"BackImages_title__1hlsp","images":"BackImages_images__1ATKH"};